'use es6';

import { Map as ImmutableMap } from 'immutable';
import { inferVisualization } from 'reporting-ui-components/reports/inferLogic/inferVisualization';
import { ColorEncoding } from 'reporting-visualizations/visualizations/xy/xyRecords';
import resolve from './resolve';
import { getTooltipFormatter, getDrilldownColumns } from './visualization';
import SalesAnalyticsReport from '../lib/salesAnalytics/SalesAnalyticsReport';
import { isSearch, isTable, COLOR_BY_DEAL_CHANGE_TYPE } from '../lib/salesAnalytics/helpers';
import { callWidgetDrilldown } from '../lib/salesAnalytics/drilldowns';
import { jsx as _jsx } from "react/jsx-runtime";
const getVisualization = (report, data, {
  onDrilldown
}) => {
  const visualization = inferVisualization(report, data);
  const onClick = callWidgetDrilldown(report, onDrilldown);
  if (isSearch(report)) {
    return visualization.set('columns', getDrilldownColumns());
  }
  if (isTable(report)) {
    return visualization.setIn(['columns', 1, 'onClick'], onClick);
  }
  return visualization.set('events', {
    onPointClick: onClick
  }).setIn(['layers', 0, 'color'], ColorEncoding({
    field: 'deal_change_type',
    defined: ImmutableMap(COLOR_BY_DEAL_CHANGE_TYPE)
  })).setIn(['style', 'tooltipFormatter'], getTooltipFormatter(report, visualization.getIn(['data', 'primary'])));
};
const Index = props => /*#__PURE__*/_jsx(SalesAnalyticsReport, Object.assign({}, props, {
  resolveReport: resolve,
  getVisualization: getVisualization
}));
export default Index;